/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_CancelInputs */

const en_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_context_menu_delete_cancel = /** @type {(inputs: Context_Menu_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Context_Menu_Delete_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_cancel = /** @type {((inputs?: Context_Menu_Delete_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_delete_cancel(inputs)
	if (locale === "de") return de_context_menu_delete_cancel(inputs)
	if (locale === "it") return it_context_menu_delete_cancel(inputs)
	if (locale === "ru") return ru_context_menu_delete_cancel(inputs)
	if (locale === "es") return es_context_menu_delete_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_delete_cancel(inputs)
	if (locale === "ja") return ja_context_menu_delete_cancel(inputs)
	if (locale === "hi") return hi_context_menu_delete_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_delete_cancel(inputs)
	return en_context_menu_delete_cancel(inputs)
});